import * as baseIcons from '@tamagui/lucide-icons'
import { VirginRed } from './VirginRed'
import { Member } from './Member'
import { Search } from './Search'

const Icon = {
  ...baseIcons,
  VirginRed,
  Search,
  Member,
}

export { Icon }
